/******************************** Import Package ************************************/
import React from "react";
import {
  Grid,
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  Typography,
} from "@mui/material";
import { Link } from "react-router-dom";
import styled from "styled-components";

/******************************** Styled Components ************************************/
const StyledCard = styled(Card)`
  margin: 1px;
  margin-top: 1rem;
  box-shadow: 3px 3px 6px rgba(0, 0, 0, 0.2);

  a {
    color: inherit;
    text-decoration: none;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    width: 100%;

    &:hover {
      background-color: #9acad6;
      color: red;
    }
  }
`;

const Alignment1 = styled(CardActionArea)`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 40%;
  background: #4e9a98;
`;

const CardValue = styled(CardActions)`
  display: flex;
  flex-direction: column;
  width: 100%;
  color: #4e9a98;
  text-align: center;
  font-size: 16px;
`;

const CardContentStyled = styled(CardContent)`
  padding: 2rem;
`;

const IconWrapper = styled(Typography)`
  color: white;
`;

/******************************** Card Component ************************************/
export default function Cards({ name, value, icon, link }) {
  return (
    <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
      <StyledCard className="dashboard-card">
        <Link to={`/${link}`}>
          <Alignment1>
            <CardContentStyled>
              <IconWrapper
                gutterBottom
                variant="h5"
                component="h6"
                align="left"
              >
                {icon}
              </IconWrapper>
            </CardContentStyled>
          </Alignment1>
          <CardValue>
            <Typography component="p">{name}</Typography>
            <Typography gutterBottom variant="h4" component="p">
              {value}
            </Typography>
          </CardValue>
        </Link>
      </StyledCard>
    </Grid>
  );
}
